/* DripDiscount — app.js */
(function () {
  'use strict';
  var S = window.DD || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Panneaux latéraux ---------- */
  var veil = null;
  function getVeil() {
    if (!veil) { veil = $('#ddVeil'); }
    return veil;
  }
  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    var v = getVeil(); if (v) v.classList.add('is-on');
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    $$('.dd-drawer').forEach(function (d) { d.classList.remove('is-open'); });
    var v = getVeil(); if (v) v.classList.remove('is-on');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-panel]');
    if (o) { e.preventDefault(); openPanel($('#' + o.getAttribute('data-panel'))); return; }
    if (e.target.closest('[data-panel-close]') || e.target.id === 'ddVeil') { closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- Recherche en tête ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var bar = $('#ddSearch');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) { var i = $('input[name="q"]', bar); if (i) i.focus(); }
  });

  var sTimer = null;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-live-search]')) return;
    var q = e.target.value.trim();
    var out = $('#ddSugg');
    if (!out) return;
    clearTimeout(sTimer);
    if (q.length < 3) { out.innerHTML = ''; return; }
    sTimer = setTimeout(function () {
      fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&section_id=quick-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = document.createElement('div');
          d.innerHTML = html;
          var inner = d.querySelector('[data-sugg-inner]');
          out.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function () { out.innerHTML = ''; });
    }, 240);
  });

  /* ---------- Accordéons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-acc]');
    if (!b) return;
    var item = b.closest('.dd-qa__i');
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (item) item.classList.toggle('is-open', !open);
  });

  /* ---------- Galerie produit ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var wrap = t.closest('.dd-gal');
    var main = $('[data-gal-main] img', wrap);
    if (main) {
      main.src = t.getAttribute('data-src');
      main.srcset = '';
      main.alt = t.getAttribute('data-alt') || main.alt;
    }
    $$('[data-thumb]', wrap).forEach(function (x) { x.classList.remove('is-on'); });
    t.classList.add('is-on');
  });

  /* ---------- Quantité ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var box = b.closest('.dd-qty');
    var input = $('input', box);
    var v = parseInt(input.value, 10) || 1;
    v += (b.getAttribute('data-qty') === 'up' ? 1 : -1);
    input.value = v < 1 ? 1 : v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Sélection de variante ---------- */
  function money(cents) {
    var f = (S.moneyFormat || '{{amount_with_comma_separator}} €');
    var v = (cents / 100).toFixed(2).replace('.', ',');
    var vd = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v)
            .replace(/\{\{\s*amount\s*\}\}/, vd)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  $$('[data-product-form]').forEach(function (form) {
    var root = form.closest('[data-product-root]');
    if (!root) return;
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);

    function current() {
      var chosen = $$('input[data-opt]:checked', root).map(function (i) { return i.value; });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }

    function paint() {
      var v = current();
      var idInput = $('[data-variant-id]', root);
      var btn = $('[data-add]', root);
      var sticky = $('[data-sticky-add]', root);

      $$('[data-opt-current]', root).forEach(function (n) {
        var i = parseInt(n.getAttribute('data-opt-current'), 10);
        var c = $$('input[data-opt]:checked', root)[i];
        if (c) n.textContent = c.value;
      });

      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Combinaison indisponible'; }
        if (sticky) { sticky.disabled = true; sticky.textContent = 'Indisponible'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      $$('[data-price-now]', root).forEach(function (n) { n.textContent = money(v.price); });
      $$('[data-price-was]', root).forEach(function (n) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          n.textContent = money(v.compare_at_price);
          n.style.display = '';
        } else { n.style.display = 'none'; }
      });
      var sv = $('[data-sticky-variant]', root);
      if (sv) sv.textContent = v.options.join(' · ');
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      }
      if (sticky) {
        sticky.disabled = !v.available;
        sticky.textContent = v.available ? 'Ajouter' : 'Épuisé';
      }
      $$('[data-stock-for]', root).forEach(function (n) {
        n.hidden = String(n.getAttribute('data-stock-for')) !== String(v.id);
      });
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    $$('input[data-opt]', root).forEach(function (i) { i.addEventListener('change', paint); });
    paint();
  });

  /* ---------- Estimation de livraison ---------- */
  function isWorkday(d) { var x = d.getDay(); return x !== 0 && x !== 6; }
  function addWorkdays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (isWorkday(d)) added++; }
    return d;
  }
  var FMT = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  $$('[data-eta]').forEach(function (box) {
    var cut = parseInt(box.getAttribute('data-cutoff'), 10);
    var mn = parseInt(box.getAttribute('data-min'), 10);
    var mx = parseInt(box.getAttribute('data-max'), 10);
    var now = new Date();
    var base = new Date(now.getTime());
    var sameDay = isWorkday(now) && now.getHours() < cut;
    if (!sameDay) { base = addWorkdays(now, 1); }
    var a = addWorkdays(base, mn);
    var b = addWorkdays(base, mx);
    var r = $('[data-eta-range]', box);
    if (r) r.textContent = 'entre ' + FMT.format(a) + ' et ' + FMT.format(b);
    var s = $('[data-eta-ship]', box);
    if (s) s.textContent = sameDay ? '— commande expédiée aujourd\u0027hui si validée avant ' + cut + 'h' : '— prochaine expédition le prochain jour ouvré';
  });

  /* ---------- Compteur panier ---------- */
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (n) {
        n.textContent = c.item_count;
        n.hidden = c.item_count === 0;
      });
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-product-form]')) return;
    e.preventDefault();
    var btn = $('[data-add]', f);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Ajouté ✓'; }
        refreshCount();
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1400);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- Tri collection ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort]')) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', e.target.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- Panier : quantités ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-qty]')) return;
    var key = e.target.getAttribute('data-key');
    var q = Math.max(0, parseInt(e.target.value, 10) || 0);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: q })
    }).then(function () { window.location.reload(); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-remove]');
    if (!b) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: 0 })
    }).then(function () { window.location.reload(); });
  });

  refreshCount();

  /* ---------- Guide des tailles ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-size-open]')) {
      var m = $('#ddSize');
      if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-size-close]') || (e.target.classList && e.target.classList.contains('dd-modal'))) {
      var mm = $('#ddSize');
      if (mm) { mm.classList.remove('is-open'); document.body.style.overflow = ''; }
      return;
    }
    var tab = e.target.closest('[data-pane]');
    if (tab) {
      var box = tab.closest('.dd-modal__bd');
      $$('[data-pane]', box).forEach(function (t) { t.classList.remove('is-on'); });
      tab.classList.add('is-on');
      var id = tab.getAttribute('data-pane');
      $$('[data-pane-id]', box).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-pane-id') === id); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = $('#ddSize');
    if (m && m.classList.contains('is-open')) { m.classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  /* ---------- Vidéos clients ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vid-play]');
    if (!b) return;
    var box = b.closest('[data-vid]');
    var vid = $('video', box);
    if (!vid) return;
    $$('[data-vid]').forEach(function (o) {
      if (o === box) return;
      var ov = $('video', o);
      if (ov) { ov.pause(); }
      o.classList.remove('is-playing');
    });
    vid.setAttribute('controls', 'controls');
    vid.play();
    box.classList.add('is-playing');
    vid.addEventListener('pause', function () { box.classList.remove('is-playing'); }, { once: true });
    vid.addEventListener('ended', function () { box.classList.remove('is-playing'); }, { once: true });
  });

  /* ---------- Barre d'achat collante ---------- */
  (function () {
    var bar = $('[data-sticky]');
    if (!bar) return;
    var form = $('[data-product-form]');
    var anchor = $('[data-add]');
    if (!form || !anchor) return;

    var stickyBtn = $('[data-sticky-add]', bar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    function toggle() {
      var r = anchor.getBoundingClientRect();
      var past = r.bottom < 0;
      var atFooter = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 220);
      bar.classList.toggle('is-on', past && !atFooter);
    }
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
    toggle();
  })();
})();
